<template >
  <b-container fluid>
    <b-row>
      <b-col cols="12" sm="10" md="8" lg="3">
        <b-form-group label="Tipo de reporte:">
          <b-form-select size="sm" v-model="$v.reportesFormModel.inSelectTipoReporte.$model" :options="catalogReportes.reportes" />
          <div class="error" v-if="!$v.reportesFormModel.inSelectTipoReporte.required">Este campo es obligatorio.</div>
        </b-form-group>
      </b-col>
      <b-col cols="12" sm="10" md="8" lg="2">
          <b-form-group label="fecha inicial">
              <b-form-input size="sm" :state="!$v.reportesFormModel.inDate1.$invalid" type="date" id="F1" v-model="$v.reportesFormModel.inDate1.model.$model" ></b-form-input>
              <div class="error" v-if="!$v.reportesFormModel.inDate1.model.minValue">La fecha esta fuera del rango.</div>
              <div class="error" v-if="!$v.reportesFormModel.inDate1.model.maxValue">La fecha esta fuera del rango.</div>
              <div class="error" v-if="!$v.reportesFormModel.inDate1.model.required">Este campo es obligatorio.</div>
              <div class="error" v-if="!$v.reportesFormModel.inDate1.model.sameYear">Las fechas deben ser del mismo año.</div>
          </b-form-group>
      </b-col>
      <b-col cols="12" sm="10" md="8" lg="2" v-if="!reportesFormModel.inSelectTipoReporte.includes('eimpresión Recibos del')">
          <b-form-group label="Fecha final">
              <b-form-input size="sm" :state="!$v.reportesFormModel.inDate2.$invalid" type="date" v-model="$v.reportesFormModel.inDate2.model.$model" ></b-form-input>
              <div class="error" v-if="!$v.reportesFormModel.inDate2.model.minValue">La fecha esta fuera del rango.</div>
              <div class="error" v-if="!$v.reportesFormModel.inDate2.model.maxValue">La fecha esta fuera del rango.</div>
              <div class="error" v-if="!$v.reportesFormModel.inDate2.model.required">Este campo es obligatorio.</div>
              <div class="error" v-if="!$v.reportesFormModel.inDate2.model.sameYear">Las fechas deben ser del mismo año.</div>
          </b-form-group>
      </b-col>


      <!-- 
      
      v-if="reportesFormModel.inSelectTipoReporte=='Recibos Emitidos' || 
                  reportesFormModel.inSelectTipoReporte=='Recibos Cancelados' ||
                  reportesFormModel.inSelectTipoReporte=='Facturación Recibos Emitidos' ||
                  reportesFormModel.inSelectTipoReporte=='Facturación Recibos Cancelados' ||
                   reportesFormModel.inSelectTipoReporte=='Diario de Ingreso Detallado' || 
                   reportesFormModel.inSelectTipoReporte=='Diario de Ingreso Concentrado' ||
                   reportesFormModel.inSelectTipoReporte.includes('Poliza') ||
                   reportesFormModel.inSelectTipoReporte.includes('eimpresión Recibos del') ||
                   reportesFormModel.inSelectTipoReporte.includes('cajero auto') ||
                   reportesFormModel.inSelectTipoReporte.includes('xlsx')  ||
                   reportesFormModel.inSelectTipoReporte.includes('predial flujo de efectivo') ||
                   reportesFormModel.inSelectTipoReporte.includes('predial corriente y rezago') ||
                   reportesFormModel.inSelectTipoReporte.includes('agua flujo de efectivo') ||
                   reportesFormModel.inSelectTipoReporte.includes('agua corriente y rezago') " -->

      <b-col cols="12" sm="10" md="8" lg="2" style="cursor:pointer" v-if="reportesFormModel.inSelectTipoReporte!=null && !reportesFormModel.inSelectTipoReporte.includes('por oficina')">
        Usuario
        <b-input-group class="mt-2">
          <!-- <b-form-select size="sm" v-model="reportesFormModel.inSelectUser.model" :options="catalogReportes.usuariosReportes"  /> -->
          
          <b-form-input size="sm" disabled @click="mostrarModalUsuarios" v-model="usuariosSelTxt"  ></b-form-input>
            <!-- <b-icon icon="list" @click="mostrarModalUsuarios" style="cursor:pointer"></b-icon>  -->
          <b-input-group-prepend @click="mostrarModalUsuarios" is-text >
              <b-icon icon="people-fill"></b-icon>
            </b-input-group-prepend>  
        </b-input-group>
      </b-col>
      <b-col cols="12" sm="10" md="8" lg="2" style="cursor:pointer" v-if="reportesFormModel.inSelectTipoReporte!=null && reportesFormModel.inSelectTipoReporte.includes('por oficina')">
        <b-form-group label="Oficina:">
          <b-form-select size="sm"  right  v-model="reportesFormModel.inSelectOficinaDirDepto.model" :options="catalogReportes.oficinasConsulta"  />
        </b-form-group>
      </b-col>

      

      <b-col cols="12" sm="10" md="8" lg="3" v-if="reportesFormModel.inSelectTipoReporte.includes('Diario de Ingreso Detallado') || reportesFormModel.inSelectTipoReporte.includes('Diario de Ingreso Concentrado') || reportesFormModel.inSelectTipoReporte.includes('xlsx') ">
        <b-form-group label="Concepto:">
          <b-form-select size="sm"  right  v-model="reportesFormModel.inSelectConcepto" :options="catalogReportes.conceptos"  />
        </b-form-group>
      </b-col>

    </b-row>
    
    <b-row>
      <b-col cols="12" lg="6">
          <b-alert variant="warning" :show="msgErrorReportes != ''" style="white-space: pre-line;">
              {{msgErrorReportes}}
          </b-alert>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" md="8" lg="2" class="mt-2">
        <b-button block @click="generarReporte" variant="success" size="sm">
          <b-spinner v-if="isGenerando"></b-spinner>
          <strong v-if="isGenerando">&nbsp;&nbsp;Generando Reporte. . .</strong>
          <strong v-if="!isGenerando">Generar Reporte </strong>
          <b-icon icon="arrow-right-circle" v-if="!isGenerando"/>
        </b-button>
      </b-col>
    </b-row>
    <!--<br><b-button @click="calculaTotalConceptos(conceptos)">Sumar conceptos</b-button><br>{{totalRegistroCivil/100}}-->

    <b-modal v-model="verUsuarios" size="md" title="Seleccione los usuarios" header-bg-variant="dark" header-text-variant="light" hide-footer>
      <b-row>
        <b-col v-if="existsTodos" class="mt-2 mb-2"><b-form-checkbox v-model="reportesFormModel.inChk.model"><b>TODOS LOS USUARIOS</b></b-form-checkbox></b-col>
        <b-col cols="12" >
          <b-form-select size="sm" v-model="reportesFormModel.inSelectUser.modelArr" value-field="usuario" text-field="usuario"  multiple :select-size="catalogReportes.usuariosReportesSel.length+this.catalogReportes.oficinas.length+2" :disabled="reportesFormModel.inChk.model">
            <b-form-select-option-group :label="oficina" v-for="oficina in catalogReportes.oficinas" :key="oficina" >
            
                <b-form-select-option  :value="usuario.usuario" v-for="usuario in usuariosOficina[oficina]" :key="usuario.usuario+oficina" >
                  {{usuario.usuario}}
                </b-form-select-option>
              
              
            </b-form-select-option-group>
          </b-form-select>
           
        
        
        </b-col>
        <b-col cols="12" align="center" class="mt-3 mb-2">
          <b-button variant="info" pill @click="verUsuarios=false">Aceptar</b-button>
          <br>
        </b-col>
      </b-row>

    </b-modal>
  </b-container>
  
</template>

<script>
  import { mapState} from 'vuex'
  import { server, server2, checkAuth, getPostConfig, handledError } from '@/axios-tools'
  import axios from 'axios'
  import { required } from 'vuelidate/lib/validators'

  export default {
    computed: mapState ({
      isGenerando: state => state.reportes.isGenerando,
      reportesFormModel: state => state.reportes.reportesFormModel,
      msgErrorReportes: state => state.reportes.msgErrorReportes,
      catalogReportes: state => state.reportes.catalogReportes,
      token: state => state.login.token,
      usuariosOficina :function(){
        let usrs ={};
        for(let idx in this.catalogReportes.oficinas){
          let oficina = this.catalogReportes.oficinas[idx]
            usrs[oficina]=[];
            for(let idxU in this.catalogReportes.usuariosReportesSel){
              let usuario = this.catalogReportes.usuariosReportesSel[idxU]
              if(usuario.oficina == oficina){
                usrs[oficina].push(usuario)
              }
            }
        }
        return usrs
      },
      usuariosSelTxt:function(){
        
          return this.reportesFormModel.inChk.model ? 'TODOS' : this.reportesFormModel.inSelectUser.modelArr.length>1? 'MULTIUSUARIO' : this.reportesFormModel.inSelectUser.modelArr.length==1? this.reportesFormModel.inSelectUser.modelArr[0] : '';
        
      },
      existsTodos(){
        let e = false;
        for(let idx in this.catalogReportes.usuariosReportesSel){
          
          if(this.catalogReportes.usuariosReportesSel[idx].usuario.includes('TODOS')){e=true}

        }
        
        return e;
      }
    }),
    mounted(){
      this.cleanResults();
    },
    data () {
      return {
        conceptos:[
          {concepto:"Registro Civil", cifra:"24663.22"},
          {concepto:"Registro Civil", cifra:"12120.43"},
          {concepto:"Registro Civil", cifra:"1843.44"}
        ],
        totalRegistroCivil:0,
        verUsuarios : false,
      }
    },
    methods: {
      cleanResults(){
        this.$store.commit("updateReporte", null);
        this.$store.commit("updateMsgErrorReportes", "");
        let tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
    
        this.reportesFormModel.inDate1.model = new Date(Date.now() - tzoffset).toISOString().substring(0,10)
        this.reportesFormModel.inDate2.model = new Date(Date.now() - tzoffset).toISOString().substring(0,10)

        this.reportesFormModel.guardaReporte=false;

      },
      mostrarModalUsuarios(){
        this.verUsuarios = true;
        this.$store.commit("updateB64PdfReporte", null);
        this.$store.commit("updateReporte", []);
        this.$store.commit("updateMsgErrorReportes", "");

      },
      /*
      Estos eran para cuando los datos se traian en crudo del sevridor y se procesaban en el cliente para mostrarlos en graficas
      generarReporte(){
        if(!this.isGenerando & checkAuth(this.$router, this.$store)){
          this.$store.commit("updateIsGenerando", true);
          this.cleanResults();
          axios(
            getPostConfig(server.reportes, this.reportesFormModel, this.token)
            ).then(res => {
              this.$store.commit("updateReporte", res.data);
              this.$store.commit("updateIsGenerando", false);
          }).catch(err => {
              this.$store.commit("updateIsGenerando", false);
              handledError(err, server.reportes, this.$router, this.$store);
          })
        }
      },
      calculaTotalConceptos(conceptos){
        var totalRegistroCivil=0;
        for(var idx=0; conceptos.length > idx; idx++){
          switch (conceptos[idx].concepto) {
            case "Registro Civil":
              var stringToNumber = conceptos[idx].cifra * 100;
              totalRegistroCivil = totalRegistroCivil + stringToNumber;
              break;
          
            default:
              break;
          }
        }
        this.totalRegistroCivil = totalRegistroCivil
      },*/
      generarReporte(){
        if(!this.isGenerando & checkAuth(this.$router, this.$store) && this.reportesFormModel.inSelectUser.modelArr!=null ){
          this.$store.commit("updateB64PdfReporte", null);
          this.$store.commit("updateIsGenerando", true);
          this.$store.commit("updateReporte", []);
          this.$store.commit("updateMsgErrorReportes", "");

          
          let mismoDia = (this.reportesFormModel.inDate1.model == this.reportesFormModel.inDate2.model );
          
          let serverDest = this.reportesFormModel.inSelectTipoReporte.includes('xlsx')  || 
                            !mismoDia ? server2 : server;

          if(serverDest==server2){
            this.reportesFormModel.guardaReporte = true;
          }else{
            this.reportesFormModel.guardaReporte = false;
          }

          this.reportesFormModel.inTipoFiltro = this.reportesFormModel.inSelectTipoReporte.includes('por oficina') ? 'Oficina' : 'Usuario';

          axios(
            getPostConfig(serverDest.reportes, this.reportesFormModel, this.token)
            ).then(res => {
              if(res.data!=null){
                this.$store.commit("updateReporte", res.data);
              }else{
                alert('No existen resultados para generar el reporte');
              }
              this.$store.commit("updateIsGenerando", false);
          }).catch(err => {
              this.$store.commit("updateIsGenerando", false);
              

              handledError(err, server.reportes, this.$router, this.$store);
          })
          
        }
      }

    },
    validations: {
      reportesFormModel: {
        inDate1:{
           model:{
              required,
              minValue: value => value > new Date(1999,0,1).toISOString(),
              maxValue: value => value < new Date(new Date().getFullYear(),11,31).toISOString(),
              
              sameYear: function(){return this.reportesFormModel.inDate2.model.substring(0,4) == 
                                              this.reportesFormModel.inDate1.model.substring(0,4)}
          }
        },
        inDate2:{
           model:{
              required,
              minValue: value => value > new Date(1999,0,1).toISOString(),
              maxValue: value => value < new Date(new Date().getFullYear(),11,31).toISOString(),
              
              sameYear: function(){return this.reportesFormModel.inDate2.model.substring(0,4) == 
                                              this.reportesFormModel.inDate1.model.substring(0,4)}
                                              
          }
        },
        inSelectTipoReporte:{
          required
        },
      }
    }
  }
</script>